module.exports = __webpack_public_path__ + "assets/img/gdzq.397b96c8.png";